import type {
  LabwareSerializationError,
  MaybeWorkflowConfig,
  TaskSerializationError,
} from '../features/workflowJsonSelectors';
import type { PreviewBlocker, PreviewBlockerKey } from '../text';
import { previewBlockers } from '../text';

export const isBlockerKey = (key: string): key is PreviewBlockerKey =>
  key in previewBlockers;

export const toPreviewBlockers = (
  workflowConfig: MaybeWorkflowConfig
): PreviewBlocker[] => {
  if (!workflowConfig.isError) return [];

  const errors = workflowConfig.errors.flatMap((error) =>
    isBlockerKey(error.message)
      ? {
          ...previewBlockers[error.message],
          ...(error.hasOwnProperty('taskId')
            ? { taskId: (error as TaskSerializationError).taskId }
            : {}),
          ...(error.hasOwnProperty('labwareId')
            ? { labwareId: (error as LabwareSerializationError).labwareId }
            : {}),
        }
      : []
  );

  const mergedErrorsObj = errors.reduce((acc, error) => {
    const taskIds = [
      ...(acc[error.title]?.taskIds ?? []),
      error.taskId ?? '',
    ] as string[];
    const labwareIds = [
      ...(acc[error.title]?.labwareIds ?? []),
      error.labwareId ?? '',
    ] as string[];

    return {
      ...acc,
      [error.title]: {
        title: error.title,
        description: error.description,
        taskIds,
        labwareIds,
      },
    };
  }, {} as Record<string, PreviewBlocker>);

  return Object.values(mergedErrorsObj);
};
